<template>
  <ul role="list" class="my-1 divide-y divide-untitled-gray-200">
    <li v-for="i in lineCount" :key="i" class="py-1">
      <el-skeleton animated class="flex items-start my-1">
        <template #template>
          <div class="w-full mt-3 block">
            <el-skeleton-item variant="h4" class="h4" />
          </div>
        </template>
      </el-skeleton>
    </li>
  </ul>
</template>

<script setup>
import { ElSkeleton, ElSkeletonItem } from "element-plus";
import { defineProps } from "vue";

defineProps({
  lineCount: {
    type: Number,
    default: 8,
  },
});
</script>
